const pageFooter = {
  hipaaBadgeWordmarkTop: "HIPAA",
  hipaaBadgeWordmarkBottom: "COMPLIANT",
} as const;

export { pageFooter };
